export default "__VITE_ASSET__9x2Mvc94__"